export default "__VITE_ASSET__KyeUaPCM__"